import React from 'react';
import propTypes from 'prop-types';
import { getCompany } from 'helpers/getCompanyVariables';
import AgentOwnerCard from 'tailwind-components/Sidebar/AgentOwnerCard';
import parse from 'html-react-parser';
import SidebarContent from 'tailwind-components/ContentWithSidebar/SidebarContent';

const company = getCompany();
const isOneill = company === 'oneill';

export default function AnswerDetails({ question }) {
  const isYouTubeUrl = url => {
    return url.includes('youtube.com') || url.includes('youtu.be');
  };

  const getYouTubeId = url => {
    const match = url.match(
      /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/)|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/v\/|youtube\.com\/watch\?v=|youtube\.com\/watch\?.+&v=|youtube\.com\/playlist\?list=)([a-zA-Z0-9_-]{11})/
    );
    return match ? match[1] : null;
  };

  const answerContent = question.answer ?? 'No answer provided';
  const parsedAnswer = parse(answerContent);
  const videoUrl = question.answerVideo;
  const isYouTube = videoUrl ? isYouTubeUrl(videoUrl) : null;
  const youTubeId = isYouTube ? getYouTubeId(videoUrl) : null;

  return (
    <SidebarContent includesHeader dataTour='faqs-answer' className='p-0 gap-0'>
      <div className='flex-1 min-h-0 overflow-y-auto overflow-x-hidden p-4 flex flex-col gap-4 show-scrollbar'>
        <h3 className='m-0'>{question.question}</h3>
        <div className='[&_ul]:list-disc [&_ul]:list-inside [&_ol]:list-decimal [&_ol]:list-inside [&_li]:mb-1 [&_li]:pl-2'>{parsedAnswer || 'No Answer Avilable'}</div>
        {question.answerImg && <img src={question.answerImg} alt='Answer' />}
        {videoUrl && (
          <div className='w-full'>
            {isYouTube ? (
              <iframe
                className='w-full aspect-video'
                src={`https://www.youtube.com/embed/${youTubeId}`}
                title='YouTube video player'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                allowFullScreen
              ></iframe>
            ) : (
              <video className='w-full aspect-video' controls>
                <source src={videoUrl} type='video/mp4' />
                <track kind='captions' src='' srcLang='en' label='English' />
              </video>
            )}
          </div>
        )}
      </div>
      {isOneill && (
        <AgentOwnerCard
          title="Didn't find an answer?"
          subtitle='Reach out to your agent consultant!'
          showBookingButton={false}
        />
      )}
    </SidebarContent>
  );
}

AnswerDetails.propTypes = {
  question: propTypes.object.isRequired
};
